class DLPageRelatedArticlesM extends HTMLElement {
  constructor() {
    super();
    this.glideContainer = this.querySelector('.glide');
    this.pagination = this.querySelector('[data-related-articles-pagination]');
    this.paginationItems = Array.from(this.querySelectorAll('.dl-page-related-articles-m-pagination-item'));
    this.articleCount = this.paginationItems.length || this.querySelectorAll('.dl-page-related-articles-m-card').length;

    this.initializeGlide();
    this.initializePagination();
  }

  initializeGlide() {
    if (!this.glideContainer || this.articleCount < 2 || typeof Glide === 'undefined') return;

    this.glide = new Glide(this.glideContainer, {
      type: 'carousel',
      startAt: 0,
      perView: 4,
      gap: 16,
      bound: true,
      breakpoints: {
        990: {
          perView: 1.28,
          gap: 20,
        },
      },
    });

    this.glide.on('run.after', () => this.updatePagination(this.glide.index));
    this.glide.mount();
  }

  initializePagination() {
    if (!this.pagination || !this.paginationItems.length) return;

    this.paginationItems.forEach((item) => {
      item.addEventListener('click', () => this.goTo(Number(item.dataset.index)));
    });

    const getIndexFromPointer = (event) => {
      const rect = this.pagination.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(0.9999, (event.clientX - rect.left) / rect.width));
      return Math.floor(ratio * this.articleCount);
    };

    this.pagination.addEventListener('pointerdown', (event) => {
      this.pagination.setPointerCapture?.(event.pointerId);
      this.isDraggingPagination = true;
      this.goTo(getIndexFromPointer(event));
    });

    this.pagination.addEventListener('pointermove', (event) => {
      if (!this.isDraggingPagination) return;
      event.preventDefault();
      this.goTo(getIndexFromPointer(event));
    });

    const stopDragging = () => {
      this.isDraggingPagination = false;
    };

    this.pagination.addEventListener('pointerup', stopDragging);
    this.pagination.addEventListener('pointercancel', stopDragging);
  }

  goTo(index) {
    const safeIndex = Math.max(0, Math.min(this.articleCount - 1, index));
    this.updatePagination(safeIndex);
    this.glide?.go(`=${safeIndex}`);
  }

  updatePagination(index) {
    const normalizedIndex = ((index % this.articleCount) + this.articleCount) % this.articleCount;

    this.paginationItems.forEach((item, itemIndex) => {
      const isActive = itemIndex === normalizedIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}

if (!customElements.get('dl-page-related-articles-m')) {
  customElements.define('dl-page-related-articles-m', DLPageRelatedArticlesM);
}
